<script>
export default {

    name: 'suspend-modal',

    props:
    {
        items: Array,
        noButton: Boolean,
        type: String,
    },

    computed:
    {
        ids()
        {
            let array = []
            if (this.items) {
                for (let i = 0; i < this.items.length; i++) {
                    array.push(this.items[i].id)
                }
                return array
            }
        }
    },

    methods: {
        openModal()
        {
            this.$refs.suspendModal.open()
        },
        suspend()
        {
            this.$store.dispatch(this.type, {ids: this.ids,action: 'suspend',}).then( res=>{
                this.$emit('fetch')
                this.cancel()
            })
        },
        cancel()
        {
            this.$refs.suspendModal.close()
        }
    }

}
</script>

<template lang="html">
    <custom-modal exitIcon="fas fa-pause-circle"" ref="suspendModal">
        <custom-button slot="button" v-if="!noButton" classes="white" iconBeforeText="fal fa-pause-circle fa-xs mr-2" text="Suspend" @buttonClick="openModal"></custom-button>
        <div slot="header" class="">
            <p class="text-lg font-weight-semibold">
                Suspend item
            </p>
            <template v-if="items && items.length > 0">
                <div v-for="item in items">
                    <h2 class="font-weight-bold mb-0">
                        {{ item.name }}
                    </h2>
                    <p class="text-desc-color" v-if="item.client">
                        {{ item.client.name }}
                    </p>
                </div>
            </template>
            <template v-else>
                <h2 class="font-weight-bold mb-0">
                    There are no selected items
                </h2>
            </template>
        </div>
        <div>
            <p class="text-lg font-weight-bold">Do you want this item stop displaying?</p>
            <ul class="font-awesomed-list pro pause orange m-0">
                <li>
                    A microcopy that describe suspended state
                </li>
            </ul>
        </div>
        <div slot="footer" class="">
            <custom-button classes="white w-120" text="CANCEL" @buttonClick="cancel"></custom-button>
            <custom-button :disabled="!items || items.length==0" classes="orange text-white w-120" text="SUSPEND" @buttonClick="suspend"></custom-button>
        </div>

    </custom-modal>
</template>



// WEBPACK FOOTER //
// src/components/elements/modals/suspend.vue